import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import api from '../../services/api';
import toast from 'react-hot-toast';
import { useAppSettings } from '../../hooks/useAppSettings';

export default function ForgotPassword() {
  const [form, setForm]     = useState({ login_id: '', new_password: '', confirm: '' });
  const [loading, setLoading] = useState(false);
  const [showPass, setShowPass] = useState(false);
  const navigate  = useNavigate();
  const settings  = useAppSettings();
  const headerColor = settings?.header_color || '#312e81';

  const f = (k, v) => setForm(p => ({ ...p, [k]: v }));

  const handleReset = async () => {
    if (!form.login_id.trim())     return toast.error('Please enter Login ID');
    if (!form.new_password)        return toast.error('Please enter new password');
    if (form.new_password.length < 6) return toast.error('Password must be at least 6 characters');
    if (form.new_password !== form.confirm) return toast.error('Passwords do not match');

    setLoading(true);
    try {
      const r = await api.post('/auth/reset-password-direct', {
        login_id:     form.login_id,
        new_password: form.new_password,
      });
      toast.success(r.message || 'Password reset successfully!');
      navigate('/login');
    } catch (err) {
      toast.error(err.response?.data?.message || 'Login ID not found');
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4"
      style={{ background: 'linear-gradient(135deg, #1a365d 0%, #2b6cb0 50%, #1a365d 100%)' }}>
      <div className="w-full max-w-md">

        <div className="text-center mb-8">
          <div className="w-16 h-16 rounded-full flex items-center justify-center text-white text-3xl mx-auto mb-4 shadow-lg"
            style={{ backgroundColor: headerColor }}>
            🔑
          </div>
          <h1 className="text-2xl font-bold text-white">Reset Password</h1>
          <p className="text-blue-200 text-sm mt-1">Enter your Login ID and set a new password</p>
        </div>

        <div className="bg-white rounded-2xl shadow-2xl p-8 space-y-5">

          <div>
            <label className="form-label">Login ID <span className="text-red-500">*</span></label>
            <input type="text" className="form-input" placeholder="Enter your login ID"
              value={form.login_id} onChange={e => f('login_id', e.target.value)} />
          </div>

          <div>
            <label className="form-label">New Password <span className="text-red-500">*</span></label>
            <div className="relative">
              <input type={showPass ? 'text' : 'password'} className="form-input pr-10"
                placeholder="Min 6 characters"
                value={form.new_password} onChange={e => f('new_password', e.target.value)} />
              <button type="button" onClick={() => setShowPass(p => !p)}
                className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600">
                {showPass ? '🙈' : '👁️'}
              </button>
            </div>
          </div>

          <div>
            <label className="form-label">Confirm Password <span className="text-red-500">*</span></label>
            <input type="password" className="form-input" placeholder="Re-enter new password"
              value={form.confirm} onChange={e => f('confirm', e.target.value)} />
            {form.confirm && form.new_password !== form.confirm && (
              <p className="text-xs text-red-500 mt-1">Passwords do not match</p>
            )}
          </div>

          <button onClick={handleReset} disabled={loading || form.new_password !== form.confirm}
            className="w-full py-3 rounded-xl text-white font-semibold text-sm disabled:opacity-50 transition-all"
            style={{ backgroundColor: headerColor }}>
            {loading ? '⏳ Resetting...' : '🔒 Reset Password'}
          </button>

          <div className="text-center pt-2">
            <Link to="/login" className="text-sm text-gray-500 hover:text-gray-700">
              ← Back to Login
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}